import { CloudUploadRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { DragEvent, RefObject } from 'react';

import { styles } from './ChunkedJsonUploader.styles';

type DropZoneProps = {
  isEditable: boolean;
  fileInputRef: RefObject<HTMLInputElement>;
  onFileSelected: (file: File) => void;
  onOpenFileDialog: () => void;
  onDrop: (event: DragEvent<HTMLDivElement>) => void;
};

export const DropZone = ({
  isEditable,
  fileInputRef,
  onFileSelected,
  onOpenFileDialog,
  onDrop,
}: DropZoneProps) => (
  <Stack
    data-testid="drop-zone"
    sx={styles.dropZone(isEditable)}
    onClick={isEditable ? onOpenFileDialog : undefined}
    onDragOver={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    onDrop={isEditable ? onDrop : undefined}
  >
    <input
      data-testid="file-input"
      ref={fileInputRef}
      type="file"
      accept=".json"
      style={{ display: 'none' }}
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) onFileSelected(file);
      }}
    />
    <Stack spacing={1} alignItems="center">
      <CloudUploadRounded sx={styles.fileIcon} />
      <Stack sx={{ display: 'flex', flexDirection: 'row' }}>
        <span style={{ color: '#1976d2', paddingRight: '5px' }}>
          Click to browse{' '}
        </span>{' '}
        or drop a file here
      </Stack>
    </Stack>
  </Stack>
);
